import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RestApiService } from '@draeger-academy/common';

@Component({
    selector: 'da-server-error-page',
    templateUrl: './server-error-page.component.html',
    styleUrls: ['./server-error-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ServerErrorPageComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }
}
